import React from "react";
import { useWebOnboardingSteps } from "../../hooks/useWebOnboardingSteps";
import { StepCounter, StepLayout } from "../../shared-components";
import { CarouselSlide } from "./CarouselSlide";
export const CarouselStep = () => {
  const { goForward, goBack } = useWebOnboardingSteps();
  return (
    <StepLayout>
      <StepCounter />
      <CarouselSlide goForward={goForward} goBack={goBack} />
    </StepLayout>
  );
};
